const mimetypeToExtension = {
  'image/apng': ['apng'],
  'image/gif': ['gif'],
  'image/x-icon': ['ico', 'cur'],
  'image/jpeg': ['jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp'],
  'image/png': ['png'],
  'image/svg+xml': ['svg'],
  'image/webp': ['webp'],
  'audio/webm': ['weba'],
  'audio/mpeg': ['mp3'],
  'audio/mp4': ['mp4'],
  'audio/flac': ['flac'],
  'video/webm': ['webm'],
  'video/mpeg': ['mpeg'],
  'video/mp4': ['mp4'],
  'text/csv': ['csv'],
  'application/pdf': ['pdf'],
  'application/msword': ['doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['docx'],
  'application/rtf': ['rtf']
};
const mimetypes = Object.keys(mimetypeToExtension);

export { mimetypes as a, mimetypeToExtension as m };
